// Mock data for HomeFixer360 landing page
// Brand platform: HomeFixer360 - All-in-one CRM & estimation platform for home service pros
export const mockData = {
  header: {
    logo: "HomeFixer360",
    headline: "Your Customer Acquisition Management System",
    subheadline: "HomeFixer360 is the all-in-one customer relation management system. It is a pipeline management, estimation, and lead-to-close platform built for home service pros across 8+ trades. From kitchens & baths to HVAC and driveways, we help you quote faster, book more jobs, and get paid sooner.",
    ctaText: "Get Your Free Account",
    trustBadges: [
      { icon: "shield", text: "Bank-level security" },
      { icon: "umbrella", text: "Insurance-friendly" },
      { icon: "clock", text: "24/7 availability" }
    ]
  },

  // Home service categories that HomeFixer360 supports
  serviceCategories: [
    { id: "kitchens_baths", label: "Kitchens & Baths", icon: "chef-hat", color: "orange" },
    { id: "windows_doors", label: "Windows & Doors", icon: "door-open", color: "blue" },
    { id: "decks_fencing", label: "Decks & Fencing", icon: "fence", color: "orange" },
    { id: "driveway_repaving", label: "Driveway Repaving", icon: "road", color: "blue" },
    { id: "electrical", label: "Electrical", icon: "zap", color: "orange" },
    { id: "hvac", label: "HVAC", icon: "wind", color: "blue" },
    { id: "hardscaping", label: "Hardscaping", icon: "trees", color: "orange" },
    { id: "home_renovations", label: "Home Renovations", icon: "home", color: "blue" }
  ],

  problem: {
    headline: "Stop Losing Jobs to Slow Quotes and Scattered Tools",
    points: [
      "80% of 'I'll think about it' leads never convert — speed wins",
      "Estimating jobs by hand burns hours every week",
      "Spreadsheets and texts can't keep up with busy seasons",
      "Homeowners expect instant answers, not 'I'll call you back'"
    ]
  },

  solution: {
    headline: "One Platform for Every Home Service Job",
    features: [
      {
        icon: "layout-dashboard",
        title: "All-in-One Dashboard",
        description: "Run kitchens, baths, HVAC, decks, windows, electrical and more — all from one place"
      },
      {
        icon: "calculator",
        title: "Smart Pricing Engine",
        description: "Materials, labor, and markup calculated automatically with your custom rates"
      },
      {
        icon: "cloud-rain",
        title: "Built-in CRM & Pipeline",
        description: "Track every lead from first click to paid invoice — no more lost opportunities"
      },
      {
        icon: "file-text",
        title: "Branded Proposals",
        description: "Send homeowners beautiful, on-brand proposals they can accept and sign online"
      }
    ]
  },

  howItWorks: {
    headline: "How HomeFixer360 Works",
    steps: [
      { step: 1, title: "Capture the Lead", description: "Homeowner submits job details via your branded page" },
      { step: 2, title: "Auto-Estimate", description: "Platform calculates scope and price instantly" },
      { step: 3, title: "Send Proposal", description: "Branded proposal delivered to customer inbox" },
      { step: 4, title: "Book & Get Paid", description: "Accept signature and payment online" }
    ]
  },

  benefits: {
    headline: "Why Home Service Pros Choose HomeFixer360",
    items: [
      { icon: "trending-up", title: "3X More Conversions", description: "Instant quotes beat slow competitors every time" },
      { icon: "clock", title: "Save 5 Hours/Day", description: "Stop retyping estimates and chasing paperwork" },
      { icon: "trophy", title: "Win More Bids", description: "Polished proposals build trust and close deals" },
      { icon: "zap", title: "Ready for Busy Season", description: "Handle hundreds of leads automatically" }
    ]
  },

  testimonials: [
    { id: 1, name: "Mike R.", company: "Summit Kitchen & Bath", quote: "HomeFixer360 helped us close 85% of the kitchen remodels we quoted last quarter.", rating: 5 },
    { id: 2, name: "Sarah K.", company: "Family HVAC Services", quote: "I can give homeowners an estimate while they're still on the phone.", rating: 5 }
  ],

  trustStats: [
    { label: "Trusted by Home Service Pros" },
    { label: "Used Across 8+ Trades" },
    { label: "Built for multi-trade teams" }
  ],

  pricing: {
    headline: "Choose Your Plan",
    plans: [
      {
        name: "Basic",
        price: 299,
        setupFee: 300,
        period: "month",
        description: "Perfect for small home service contractors",
        features: [
          "50 job estimates/month",
          "Up to 3 user accounts",
          "Claim management: 20/month",
          "Professional PDF proposals",
          "AI Chatbot support",
          "Email support"
        ],
        popular: false
      },
      {
        name: "Professional",
        price: 499,
        setupFee: 500,
        period: "month",
        description: "Most popular for growing businesses",
        features: [
          "200 job estimates/month",
          "Up to 7 user accounts",
          "Claim management: 50/month",
          "Custom branded proposals",
          "Priority support",
          "Remove HomeFixer360 branding"
        ],
        popular: true
      },
      {
        name: "Elite",
        price: 999,
        setupFee: 750,
        period: "month",
        description: "For large multi-trade home service companies",
        features: [
          "Unlimited job estimates",
          "Unlimited user accounts",
          "Claim management: UNLIMITED",
          "White-label proposals",
          "Priority phone support",
          "Dedicated account manager",
          "Custom training"
        ],
        popular: false
      }
    ]
  },

  faq: [
    { question: "Which home services does HomeFixer360 support?", answer: "Kitchens & baths, windows & doors, decks & fencing, driveway repaving, electrical, HVAC, hardscaping, home renovations, and more. You can customize service types for your business." },
    { question: "Do I need special equipment?", answer: "No! Just a computer or phone with internet access." },
    { question: "Can I use this for insurance claims?", answer: "Yes — our claim workflow supports property-damage jobs across multiple trades." },
    { question: "How do I get started?", answer: "Create your account, add your service categories and pricing, and send your first proposal." }
  ],

  finalCta: {
    headline: "Start Winning More Home Service Jobs Today",
    buttonText: "Get Started",
    subtext: "Cancel anytime"
  }
};
